"use strict";
import Auth from "../util/auth";
var ApiService = {
  errorHandlerWithMessage: function(message, withoutDetails) {
    var self = this;
    return function(result, a, b, c, d) {
      var url = null;
      var params = null;
      var requestId = null;
      if (result) {
        url = result.url;
        params = result.data;
        requestId = result.getResponseHeader("x-request-id");
      }
      var errorDetails = {};
      const user = Auth._currentUser;
      if (!withoutDetails) {
        errorDetails = {
          status: result.status,
          url,
          params,
          user: {
            id: user.id,
            email: user.email,
            account_alias: user.account.alias
          },
          statusText: result.statusText,
          requestId
        };
      }
      var jsonErrorMessage = null;
      if (result.responseJSON) {
        jsonErrorMessage = result.responseJSON.error_message;
      }
      var msg = jsonErrorMessage || result.status === 0 && "Unable to connect to TriumphPay Audit. Please check your network connection and try again." || message;
      if (result.status === 401) {
        Auth.reset();
        window.location.href = "/app/login";
      }
      $(self).trigger(
        "ApiService:alertError",
        [{ message: msg, details: errorDetails }]
      );
      return Promise.reject(result);
    };
  },
  addErrorHandler: function(promise, message = null, withoutDetails = null) {
    return Promise.resolve(promise).catch(
      this.errorHandlerWithMessage(
        message || "An unexpected error occurred, please try again.",
        withoutDetails
      )
    );
  }
};
export default ApiService;
